import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import {
  GetAllChamberMembersQuery,
  ShopLocalCampaignPrizeDrawParticipantsReturn,
  ShopLocalCampaignReturn,
  ShopLocalCampaignStatusEnum,
} from "../../../graphql/types";
import { getLocalTimestamp } from "../Root/RootAdmin";
import { Button, Chip, makeStyles, Modal, useMediaQuery, Menu, MenuItem, TextField, InputAdornment, IconButton } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { RedirectUri, useEnumStrings } from "../../enumStrings";
import theme from "../../../themes";
import { EndCampaignModal } from "./updateChamberShopLocalCampaign";
import { CSVLink } from "react-csv";
import CommonTable, { HeadCell } from "../../common/CommonTable";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import SearchIcon from "@material-ui/icons/Search";
import PlaylistAddCheckIcon from "@material-ui/icons/PlaylistAddCheck";
import ListIcon from "../../../images/list.png";
import EmojiEventsIcon from "@material-ui/icons/EmojiEvents";
import GetAppIcon from "@material-ui/icons/GetApp";
import GroupIcon from "@material-ui/icons/Group";

type OmittedRedeemSettingsShopLocalCampaign = ShopLocalCampaignReturn;
type AllShopLocalCampaignDataType =
  | ShopLocalCampaignReturn[]
  | undefined
  | null;
type TableShopLocalCampaignDataType = OmittedRedeemSettingsShopLocalCampaign;
type AllTableShopLocalCampaignDataType = TableShopLocalCampaignDataType[];


const useStyles = makeStyles(() => ({
  modal: {
    border: "unset",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    height: "700px",
    borderRadius: "5px",
    textAlign: "center",
    width: "740px",
    maxWidth: "100%",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    backgroundColor: "#cfd8dc",
    padding: theme.spacing(4),
    position: "relative",
  },
  modalButton: {
    margin: "10px",
    marginTop: "20px",
    width: "230px",
    backgroundColor: "#E1A731",
    color: "#e9e9e9",
    fontWeight: "bold",
    height: "40px",
  },
  desktopTableWrap: {
    width: "100%",
    maxWidth: "100%",
    overflow: "hidden",
    "& .MuiTableContainer-root": {
      overflowX: "hidden !important" as any,
    },
    "& .MuiTable-root": {
      tableLayout: "fixed" as const,
      width: "100%",
    },
    "& .MuiTableCell-root": {
      overflowWrap: "anywhere" as const,
      wordBreak: "break-word" as const,
    },
  },
  // ── Redesigned modal styles (matches Figma) ────────────────────────
  cleanModal: {
    backgroundColor: "#FFFFFF",
    borderRadius: "20px",
    width: "780px",
    maxWidth: "92vw",
    maxHeight: "90vh",
    padding: "32px 40px 28px",
    boxSizing: "border-box" as const,
    display: "flex",
    flexDirection: "column" as const,
    alignItems: "center",
    position: "relative" as const,
    fontFamily: "DM Sans, sans-serif",
    overflow: "hidden",
    "@media (max-width: 600px)": {
      width: "calc(100vw - 24px)",
      maxWidth: "calc(100vw - 24px)",
      maxHeight: "calc(100vh - 24px)",
      padding: "24px 16px 18px",
      borderRadius: "14px",
    },
  },
  cleanCloseBtn: {
    position: "absolute" as const,
    top: "18px",
    right: "18px",
    width: "32px",
    height: "32px",
    borderRadius: "50%",
    backgroundColor: "#E53935",
    color: "#FFFFFF",
    border: "none",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "16px",
    fontWeight: 700,
    boxShadow: "0 1px 3px rgba(0,0,0,0.2)",
    "&:hover": { backgroundColor: "#C71920" },
    "@media (max-width: 600px)": {
      top: "10px",
      right: "10px",
      width: "28px",
      height: "28px",
      fontSize: "14px",
    },
  },
  cleanIconCircle: {
    width: "72px",
    height: "72px",
    borderRadius: "50%",
    backgroundColor: "#24272C",
    color: "#FFFFFF",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "12px",
    "& svg": { width: "36px", height: "36px" },
    "@media (max-width: 600px)": {
      width: "56px",
      height: "56px",
      marginBottom: "10px",
      "& svg": { width: "28px", height: "28px" },
    },
  },
  cleanWinnerIconCircle: {
    width: "120px",
    height: "120px",
    borderRadius: "50%",
    backgroundColor: "#FBE9C7",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "16px",
    position: "relative" as const,
    "@media (max-width: 600px)": {
      width: "92px",
      height: "92px",
      marginBottom: "12px",
    },
  },
  cleanModalTitle: {
    fontWeight: 700,
    fontSize: "22px",
    color: "#24272C",
    margin: "0 0 8px 0",
    textAlign: "center" as const,
    fontFamily: "DM Sans, sans-serif",
    "@media (max-width: 600px)": {
      fontSize: "17px",
      lineHeight: 1.25,
    },
  },
  cleanModalDesc: {
    fontWeight: 400,
    fontSize: "14px",
    color: "#24272C",
    textAlign: "center" as const,
    margin: "0 0 18px 0",
    lineHeight: 1.5,
    maxWidth: "560px",
    fontFamily: "DM Sans, sans-serif",
    "@media (max-width: 600px)": {
      fontSize: "13px",
      margin: "0 0 14px 0",
    },
  },
  cleanTableWrap: {
    width: "100%",
    border: "1px solid #C9C9C9",
    borderRadius: "8px",
    overflow: "auto" as const,
    marginBottom: "20px",
    flex: "0 1 auto",
    maxHeight: "400px",
    "@media (max-width: 600px)": {
      maxHeight: "260px",
      marginBottom: "14px",
    },
  },
  cleanTable: {
    width: "100%",
    borderCollapse: "collapse" as const,
    fontFamily: "DM Sans, sans-serif",
    "@media (max-width: 600px)": {
      minWidth: "420px",
    },
  },
  cleanTableHead: {
    backgroundColor: "#1F2A4D",
    color: "#FFFFFF",
    fontWeight: 700,
    fontSize: "13px",
    padding: "10px 14px",
    textAlign: "center" as const,
    position: "sticky" as const,
    top: 0,
    "@media (max-width: 600px)": {
      fontSize: "11px",
      padding: "8px 10px",
    },
  },
  cleanTableCell: {
    padding: "12px 14px",
    fontSize: "13px",
    color: "#24272C",
    borderTop: "1px solid #E0E0E0",
    verticalAlign: "top" as const,
    wordBreak: "break-word" as const,
    "@media (max-width: 600px)": {
      fontSize: "11px",
      padding: "8px 10px",
    },
  },
  cleanTableCellEmail: {
    textAlign: "center" as const,
  },
  cleanActionRow: {
    display: "flex",
    gap: "16px",
    marginTop: "4px",
    flexWrap: "wrap" as const,
    justifyContent: "center",
    width: "100%",
    "@media (max-width: 600px)": {
      flexDirection: "column" as const,
      gap: "10px",
      alignItems: "stretch",
    },
  },
  cleanGoldIconBtn: {
    display: "inline-flex",
    alignItems: "center",
    gap: "10px",
    backgroundColor: "#FFFFFF",
    border: "2px solid #E1A731",
    borderRadius: "999px",
    padding: "0 22px 0 0",
    cursor: "pointer",
    color: "#E1A731",
    fontFamily: "DM Sans, sans-serif",
    fontWeight: 700,
    fontSize: "13px",
    textTransform: "uppercase" as const,
    letterSpacing: "0.04em",
    height: "52px",
    "&:hover": { backgroundColor: "#FFF7E1" },
    "&:disabled": { opacity: 0.6, cursor: "not-allowed" },
    "@media (max-width: 600px)": {
      width: "100%",
      justifyContent: "flex-start",
      height: "46px",
      fontSize: "12px",
      padding: "0 16px 0 0",
    },
  },
  cleanGoldIconCircle: {
    width: "48px",
    height: "48px",
    borderRadius: "50%",
    backgroundColor: "#E1A731",
    color: "#FFFFFF",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: "12px",
    flexShrink: 0,
    "& svg": { width: "28px", height: "28px" },
    "@media (max-width: 600px)": {
      width: "40px",
      height: "40px",
      marginRight: "10px",
      "& svg": { width: "22px", height: "22px" },
    },
  },
  cleanDarkBtn: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "10px",
    backgroundColor: "#1F2A4D",
    border: "none",
    borderRadius: "8px",
    padding: "0 26px",
    cursor: "pointer",
    color: "#FFFFFF",
    fontFamily: "DM Sans, sans-serif",
    fontWeight: 700,
    fontSize: "13px",
    textTransform: "uppercase" as const,
    letterSpacing: "0.04em",
    height: "52px",
    "&:hover": { backgroundColor: "#15203D" },
    "@media (max-width: 600px)": {
      width: "100%",
      height: "46px",
      fontSize: "12px",
      padding: "0 16px",
    },
  },
  cleanWinnerEmail: {
    color: "#E1A731",
    fontWeight: 700,
    fontSize: "16px",
    margin: "0 0 8px 0",
    fontFamily: "DM Sans, sans-serif",
  },
  cleanWinnerSubtitle: {
    color: "#24272C",
    fontSize: "14px",
    margin: 0,
    textAlign: "center" as const,
    fontFamily: "DM Sans, sans-serif",
  },
  // ── Mobile list view ──────────────────────────────────────────────
  mobileList: {
    display: "flex",
    flexDirection: "column" as const,
    gap: "12px",
    width: "100%",
  },
  mobileSearchBar: {
    width: "100%",
    marginBottom: "4px",
    "& .MuiOutlinedInput-root": {
      borderRadius: "10px",
      backgroundColor: "#FFFFFF",
      "& fieldset": { borderColor: "#E0E0E0" },
      "&.Mui-focused fieldset": { borderColor: "#000", borderWidth: "1.5px" },
    },
    "& .MuiOutlinedInput-input": {
      padding: "12px 10px",
      fontSize: "14px",
    },
  },
  mobileCard: {
    backgroundColor: "#FFFFFF",
    borderRadius: "14px",
    padding: "14px",
    color: "#24272C",
    fontFamily: "DM Sans, sans-serif",
    display: "flex",
    flexDirection: "column" as const,
    gap: "10px",
    border: "1px solid #E8E8E8",
    boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
  },
  mobileCardTop: {
    display: "flex",
    alignItems: "flex-start",
    gap: "10px",
  },
  mobileAvatar: {
    width: "40px",
    height: "40px",
    minWidth: "40px",
    borderRadius: "50%",
    backgroundColor: "#E1A731",
    color: "#FFFFFF",
    fontWeight: 700,
    fontSize: "12px",
    letterSpacing: "0.5px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  mobileTitles: {
    flex: 1,
    minWidth: 0,
    display: "flex",
    flexDirection: "column" as const,
    gap: "2px",
  },
  mobileCampaignTitle: {
    fontWeight: 700,
    fontSize: "15px",
    color: "#24272C",
    lineHeight: 1.25,
    wordBreak: "break-word" as const,
  },
  mobileCampaignSubtitle: {
    fontWeight: 400,
    fontSize: "13px",
    color: "#666",
    lineHeight: 1.3,
    wordBreak: "break-word" as const,
  },
  mobileStatusPill: {
    display: "inline-block",
    fontSize: "12px",
    fontWeight: 700,
    textTransform: "uppercase" as const,
    letterSpacing: "0.3px",
    color: "#888",
    whiteSpace: "nowrap" as const,
    alignSelf: "flex-start" as const,
    marginTop: "2px",
  },
  mobileStatusPillActive: { color: "#2E7D32" },
  mobileStatusPillUpcoming: { color: "#E1A731" },
  mobileMenuBtn: {
    color: "#666",
    padding: "2px",
    marginLeft: "2px",
  },
  mobileDivider: {
    height: "1px",
    backgroundColor: "#EEE",
    width: "100%",
  },
  mobileMetaRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: "10px",
    fontSize: "13px",
  },
  mobileMetaLabel: {
    color: "#666",
    fontWeight: 500,
  },
  mobileMetaValue: {
    color: "#24272C",
    fontWeight: 600,
    textAlign: "right" as const,
    wordBreak: "break-word" as const,
  },
  mobileBottomRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "10px",
  },
  mobileCountNumber: {
    fontSize: "24px",
    fontWeight: 700,
    color: "#24272C",
    lineHeight: 1,
  },
  mobileCountLabel: {
    fontSize: "12px",
    color: "#666",
    marginTop: "2px",
  },
  mobileViewUsersBtn: {
    backgroundColor: "#E1A731",
    color: "#FFFFFF",
    border: "none",
    borderRadius: "10px",
    padding: "8px 14px",
    fontSize: "12px",
    fontWeight: 700,
    textTransform: "none" as const,
    whiteSpace: "normal" as const,
    lineHeight: 1.2,
    minWidth: 0,
    maxWidth: "60%",
    textAlign: "center" as const,
    "&:hover": { backgroundColor: "#C8922A" },
  },
  mobileEmpty: {
    color: "#666",
    textAlign: "center" as const,
    padding: "40px 0",
    fontSize: "14px",
  },
}));

// Reusable table component for modal displays
interface ReusableTableProps<T> {
  data: T[];
  columns: {
    id: string;
    label: string;
    renderer: (item: T) => React.ReactNode;
    align?: "left" | "right" | "center";
  }[];
}

function ReusableTable<T>({ data, columns }: ReusableTableProps<T>) {
  return (
    <div style={{ height: "100%", overflow: "hidden" }}>
      <Paper
        style={{
          borderRadius: "8px",
          boxShadow: "0 1px 2px rgba(0,0,0,0.08)",
          overflow: "auto",
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  style={{
                    fontWeight: "bold",
                    fontSize: "16px",
                    padding: "16px 24px",
                    borderBottom: "1px solid rgba(224, 224, 224, 0.5)",
                    textAlign: column.align || "left",
                    backgroundColor: "#ffffff",
                  }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((item, index) => (
              <TableRow
                key={index}
                style={{
                  backgroundColor: "#ffffff",
                  borderBottom: "1px solid rgba(224, 224, 224, 0.3)",
                }}
              >
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    style={{
                      fontSize: "16px",
                      padding: "16px 24px",
                      color: "rgba(0, 0, 0, 0.87)",
                      borderBottom: "1px solid rgba(168, 168, 168, 0.3)",
                      textAlign: column.align || "left",
                    }}
                  >
                    {column.renderer(item)}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>
    </div>
  );
}

export default function FullPageShopLocalCampaignsTable({
  allShopLocalCampaignData,
  allChamberMemberData,
  mode,
}: {
  allChamberMemberData: GetAllChamberMembersQuery | undefined;
  allShopLocalCampaignData: AllShopLocalCampaignDataType;
  mode: "active" | "inactive";
}) {
  const classes = useStyles();
  const history = useHistory();
  const enumStrings = useEnumStrings();
  const isMobile = useMediaQuery("(max-width: 600px)");

  const [mobileSearch, setMobileSearch] = React.useState("");
  const [mobileMenuAnchor, setMobileMenuAnchor] = React.useState<HTMLElement | null>(null);
  const [mobileMenuCampaignId, setMobileMenuCampaignId] = React.useState<string | null>(null);

  const getInitials = (name: string) => {
    if (!name) return "?";
    const words = name.trim().split(/\s+/).filter(Boolean);
    if (words.length === 0) return "?";
    return words.slice(0, 3).map(w => w[0]).join("").toUpperCase();
  };
  const formatShortDate = (ms: number) => {
    if (!ms) return "-";
    try {
      return new Date(ms).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
    } catch {
      return "-";
    }
  };

  // Column definitions for CommonTable
  const columns: HeadCell[] = React.useMemo(() => {
    const isActive = mode === "active";
    const baseColumns: HeadCell[] = [
      {
        id: "campaignName",
        label: enumStrings.fullPageShopLocal.contestName,
        width: isActive ? "13%" : "15%",
      },
      {
        id: "prizeDescription",
        label: enumStrings.fullPageShopLocal.prizeDescription,
        width: isActive ? "20%" : "24%",
      },
      {
        id: "startDateUtcMilli",
        label: enumStrings.fullPageShopLocal.startDate,
        preventTextWrap: true,
        width: isActive ? "9%" : "10%",
      },
      {
        id: "endDateUtcMilli",
        label: enumStrings.fullPageShopLocal.endDate,
        preventTextWrap: true,
        width: isActive ? "9%" : "10%",
      },
      {
        id: "participatingMembers",
        label: enumStrings.fullPageShopLocal.participatingMembers,
        sortable: false,
        width: isActive ? "13%" : "14%",
      },
      {
        id: "prizeDrawParticipants",
        label: enumStrings.fullPageShopLocal.prizeDrawParticipants,
        sortable: false,
        width: isActive ? "14%" : "15%",
      },
      {
        id: "status",
        label: enumStrings.fullPageShopLocal.status,
        width: isActive ? "13%" : "12%",
      },
    ];
    if (isActive) {
      baseColumns.push({
        id: "updateActiveCampaign",
        label: "",
        sortable: false,
        width: "9%",
      });
    }
    return baseColumns;
  }, [enumStrings, mode]);

  // Transform data for table
  const allTableShopLocalCampaignData: AllTableShopLocalCampaignDataType =
    React.useMemo(() => {
      if (!allShopLocalCampaignData) {
        return [];
      }

      const allShopLocalCampaignsArr = (allShopLocalCampaignData || []).map(
        (shopLocalCampaignData) => ({
          ...shopLocalCampaignData,
        })
      );

      if (mode === "active") {
        return allShopLocalCampaignsArr.filter(
          (campaign) => campaign.status === ShopLocalCampaignStatusEnum.Active
        );
      }

      return allShopLocalCampaignsArr.filter(
        (campaign) => campaign.status === ShopLocalCampaignStatusEnum.Inactive
      );
    }, [allShopLocalCampaignData, mode]);

  const [memberModalOpenedForCampaignsId, setMemberModalOpenedForCampaignsId] =
    React.useState<string>("");

  const [memberModalOpenedIsActive, setMemberModalOpenedIsActive] =
    React.useState<boolean>(false);

  const [participatingMembersModalOpen, setParticipatingMembersModalOpen] =
    React.useState<boolean>(false);

  const [participantModalOpen, setParticipantModalOpen] =
    React.useState<boolean>(false);

  const [randomWinnerModalOpen, setRandomWinnerModalOpen] =
    React.useState<boolean>(false);
  const [randomWinnerEmail, setRandomWinnerEmail] = React.useState<string>("");
  const [randomWinnerCount, setRandomWinnerCount] = React.useState<number>(0);

  // Add state for sorted members
  const [sortedMembersData, setSortedMembersData] = React.useState<
    Array<{
      memberName: string;
      numberOfParticipants: number;
      participationCode: string;
    }>
  >([]);

  // Helper function to get participant emails for a member
  const getParticipantEmailsForMember = React.useCallback(
    (memberParticipationCode: string): string[] => {
      if (!memberParticipationCode || !memberModalOpenedForCampaignsId) {
        return [];
      }

      const participantEmails: string[] = [];

      for (const campaign of allShopLocalCampaignData || []) {
        if (campaign?.id === memberModalOpenedForCampaignsId) {
          const participatingMembers = campaign.participatingMembers || [];
          const prizeDrawParticipants = campaign.prizeDrawParticipants || [];

          const memberId =
            participatingMembers.find(
              (m) => m?.participationCode === memberParticipationCode
            )?.memberId || "";

          if (!memberId) {
            continue;
          }

          for (const participant of prizeDrawParticipants) {
            const redeemedIds = participant?.redeemedAtMemberIds || [];
            // Check if this participant redeemed at this member
            if (redeemedIds.includes(memberId)) {
              if (participant?.userEmail) {
                participantEmails.push(participant.userEmail);
              }
            }
          }
          break;
        }
      }

      return participantEmails;
    },
    [allShopLocalCampaignData, memberModalOpenedForCampaignsId]
  );

  const participatingMemberCompaniesTable = React.useMemo(() => {
    if (
      memberModalOpenedForCampaignsId.length > 0 &&
      (allShopLocalCampaignData || []).length > 0 &&
      (allChamberMemberData?.getAllChamberMembers || []).length > 0
    ) {
      // create object for member id to number of participants
      const participatingMembersMap: Record<string, number> = {};
      for (const campaign of allShopLocalCampaignData || []) {
        if (campaign.id === memberModalOpenedForCampaignsId) {
          for (const participantObj of campaign.prizeDrawParticipants || []) {
            for (const memberId of participantObj.redeemedAtMemberIds || []) {
              if (participatingMembersMap[memberId]) {
                participatingMembersMap[memberId] += 1;
              } else {
                participatingMembersMap[memberId] = 1;
              }
            }
          }
          break;
        }
      }

      const listOfParticipatingMembers: {
        memberName: string;
        numberOfParticipants: number;
        participationCode: string;
      }[] = [];

      for (const campaign of allShopLocalCampaignData || []) {
        if (campaign.id === memberModalOpenedForCampaignsId) {
          for (const participatingMemebrObj of campaign.participatingMembers) {
            for (const realMember of allChamberMemberData?.getAllChamberMembers ||
              []) {
              if (participatingMemebrObj.memberId === realMember.id) {
                listOfParticipatingMembers.push({
                  memberName: realMember.name,
                  numberOfParticipants:
                    participatingMembersMap[realMember.id] || 0,
                  participationCode: participatingMemebrObj.participationCode,
                });
                continue;
              }
            }
          }
          break;
        }
      }

      // 1. Filter and sort members with numberOfParticipants > 0 alphabetically
      const positiveParticipants = listOfParticipatingMembers
        .filter((member) => member.numberOfParticipants > 0)
        .sort((a, b) => a.memberName.localeCompare(b.memberName));

      // 2. Filter and sort members with numberOfParticipants === 0 alphabetically
      const zeroParticipants = listOfParticipatingMembers
        .filter((member) => member.numberOfParticipants === 0)
        .sort((a, b) => a.memberName.localeCompare(b.memberName));

      // 3. Join the two lists
      const sortedMembers = [...positiveParticipants, ...zeroParticipants];

      // Store sortedMembers in state for CSV export
      setSortedMembersData(sortedMembers);

      if (sortedMembers.length === 0) {
        return (
          <div style={{ padding: "20px", textAlign: "center" }}>
            {enumStrings.fullPageShopLocal.noneSoFar}
          </div>
        );
      }

      return (
        <div className={classes.cleanTableWrap}>
          <table className={classes.cleanTable}>
            <thead>
              <tr>
                <th className={classes.cleanTableHead}>
                  {
                    enumStrings.shopLocal.fullPageShopLocalCampaign
                      .memberCompanyName
                  }
                </th>
                <th className={classes.cleanTableHead}>
                  {
                    enumStrings.shopLocal.fullPageShopLocalCampaign
                      .participatingCode
                  }
                </th>
                <th className={classes.cleanTableHead}>
                  {
                    enumStrings.shopLocal.fullPageShopLocalCampaign
                      .usersInPrizeDraw
                  }
                </th>
              </tr>
            </thead>
            <tbody>
              {sortedMembers.map((member) => {
                const participantEmails =
                  member.numberOfParticipants > 0
                    ? getParticipantEmailsForMember(member.participationCode)
                    : [];
                return (
                  <tr key={member.participationCode}>
                    <td
                      className={`${classes.cleanTableCell} ${classes.cleanTableCellEmail}`}
                    >
                      {member.memberName}
                    </td>
                    <td
                      className={`${classes.cleanTableCell} ${classes.cleanTableCellEmail}`}
                    >
                      {member.participationCode}
                    </td>
                    <td className={classes.cleanTableCell}>
                      {participantEmails.length === 0 ? (
                        <div style={{ textAlign: "center" }}>0</div>
                      ) : (
                        <>
                          <div style={{ fontWeight: 700, marginBottom: 4 }}>
                            Total {participantEmails.length} users
                          </div>
                          <ul style={{ margin: 0, paddingLeft: "18px" }}>
                            {participantEmails.map((email) => (
                              <li key={email}>{email}</li>
                            ))}
                          </ul>
                        </>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      );
    }
    return null;
  }, [
    allChamberMemberData?.getAllChamberMembers,
    allShopLocalCampaignData,
    classes.cleanTable,
    classes.cleanTableCell,
    classes.cleanTableCellEmail,
    classes.cleanTableHead,
    classes.cleanTableWrap,
    enumStrings.fullPageShopLocal.noneSoFar,
    enumStrings.shopLocal.fullPageShopLocalCampaign.memberCompanyName,
    enumStrings.shopLocal.fullPageShopLocalCampaign.participatingCode,
    enumStrings.shopLocal.fullPageShopLocalCampaign.usersInPrizeDraw,
    memberModalOpenedForCampaignsId,
    getParticipantEmailsForMember,
  ]);

  // Add a new useCallback for sorting prize draw participants
  const sortPrizeDrawParticipantsByRedemptions = React.useCallback(
    (participants: ShopLocalCampaignPrizeDrawParticipantsReturn[]) => {
      if (participants.length === 0) return participants;

      return [...participants].sort(
        (a, b) => b.redeemedAtMemberIds.length - a.redeemedAtMemberIds.length
      );
    },
    []
  );

  const cpaUsersParticipatingInDrawList = React.useMemo(() => {
    if (
      memberModalOpenedForCampaignsId.length > 0 &&
      (allShopLocalCampaignData || []).length > 0 &&
      (allChamberMemberData?.getAllChamberMembers || []).length > 0
    ) {
      let prizeDrawParticipantArr: ShopLocalCampaignPrizeDrawParticipantsReturn[] =
        [];
      for (const campaign of allShopLocalCampaignData || []) {
        if (campaign.id === memberModalOpenedForCampaignsId) {
          prizeDrawParticipantArr = campaign.prizeDrawParticipants || [];
          break;
        }
      }
      if (prizeDrawParticipantArr.length > 0) {
        // Sort participants using the callback
        prizeDrawParticipantArr = sortPrizeDrawParticipantsByRedemptions(
          prizeDrawParticipantArr
        );
      }

      let memberIdsToPullNamesFor: string[] = [];

      for (const participantObj of prizeDrawParticipantArr) {
        for (const memberId of participantObj.redeemedAtMemberIds || []) {
          memberIdsToPullNamesFor.push(memberId);
        }
      }

      // @ts-ignore
      memberIdsToPullNamesFor = [...new Set(memberIdsToPullNamesFor)];

      const memberIdToName: {
        [key: string]: string;
      } = {};
      for (const id of memberIdsToPullNamesFor) {
        for (const member of allChamberMemberData?.getAllChamberMembers || []) {
          if (member.id === id) {
            memberIdToName[id] = member.name;
          }
        }
      }

      if (prizeDrawParticipantArr.length === 0) {
        return (
          <div style={{ padding: "20px", textAlign: "center" }}>
            {enumStrings.fullPageShopLocal.noneSoFar}
          </div>
        );
      }

      return (
        <div className={classes.cleanTableWrap}>
          <table className={classes.cleanTable}>
            <thead>
              <tr>
                <th className={classes.cleanTableHead}>
                  {
                    enumStrings.shopLocal.updateChamberShopLocalCampaign
                      .participantEmailColumn
                  }
                </th>
                <th className={classes.cleanTableHead}>
                  {
                    enumStrings.shopLocal.updateChamberShopLocalCampaign
                      .entryEarnedFromMemberColumn
                  }
                </th>
              </tr>
            </thead>
            <tbody>
              {prizeDrawParticipantArr.map((participant) => (
                <tr key={participant.userEmail}>
                  <td
                    className={`${classes.cleanTableCell} ${classes.cleanTableCellEmail}`}
                  >
                    {participant.userEmail}
                  </td>
                  <td className={classes.cleanTableCell}>
                    <ul style={{ margin: 0, paddingLeft: "18px" }}>
                      {participant.redeemedAtMemberIds
                        .filter((memberId) => Boolean(memberIdToName[memberId]))
                        .map((memberId) => (
                          <li key={memberId}>{memberIdToName[memberId]}</li>
                        ))}
                    </ul>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      );
    }

    return (
      <div style={{ padding: "20px", textAlign: "center" }}>
        {enumStrings.fullPageShopLocal.noneSoFar}
      </div>
    );
  }, [
    allChamberMemberData?.getAllChamberMembers,
    allShopLocalCampaignData,
    classes.cleanTable,
    classes.cleanTableCell,
    classes.cleanTableCellEmail,
    classes.cleanTableHead,
    classes.cleanTableWrap,
    enumStrings.fullPageShopLocal.noneSoFar,
    enumStrings.shopLocal.updateChamberShopLocalCampaign
      .entryEarnedFromMemberColumn,
    enumStrings.shopLocal.updateChamberShopLocalCampaign.participantEmailColumn,
    memberModalOpenedForCampaignsId,
    sortPrizeDrawParticipantsByRedemptions,
  ]);

  const setRandomWinnerEmailFunc = React.useCallback(() => {
    if (
      memberModalOpenedForCampaignsId.length > 0 &&
      (allShopLocalCampaignData || []).length > 0 &&
      (allChamberMemberData?.getAllChamberMembers || []).length > 0
    ) {
      let prizeDrawParticipantArr: ShopLocalCampaignPrizeDrawParticipantsReturn[] =
        [];
      for (const campaign of allShopLocalCampaignData || []) {
        if (campaign.id === memberModalOpenedForCampaignsId) {
          prizeDrawParticipantArr = campaign.prizeDrawParticipants || [];
          break;
        }
      }

      if (prizeDrawParticipantArr.length > 0) {
        // create weighted array to favour entrants with higher number of member perks redeemed
        const weightedArray: {
          userEmail: string;
          redeemedAtMemberIds: string[];
        }[] = [];

        for (const entry of prizeDrawParticipantArr) {
          for (let i = 0; i < (entry.redeemedAtMemberIds || []).length; i++) {
            weightedArray.push({
              userEmail: entry.userEmail,
              redeemedAtMemberIds: entry.redeemedAtMemberIds,
            });
          }
        }

        const randomWinner =
          weightedArray[Math.floor(Math.random() * weightedArray.length)];
        setRandomWinnerEmail(randomWinner.userEmail);
        setRandomWinnerCount(randomWinner.redeemedAtMemberIds.length);
      } else {
        setRandomWinnerEmail("");
        setRandomWinnerCount(0);
      }
    }
  }, [
    allChamberMemberData?.getAllChamberMembers,
    allShopLocalCampaignData,
    memberModalOpenedForCampaignsId,
  ]);

  const [endCampaignModalOpen, setEndCampaignModalOpen] = React.useState(false);
  const [endModalCampaignId, setEndModalCampaignId] = React.useState("");

  // Custom cell renderer
  const renderCell = React.useCallback(
    (column: HeadCell, row: TableShopLocalCampaignDataType) => {
      const isActive = row.status === ShopLocalCampaignStatusEnum.Active;
      const isUpcoming = isActive && Date.now() < row.startDateUtcMilli;

      switch (column.id) {
        case "campaignName":
          return row.campaignName;

        case "prizeDescription":
          return row.prizeDescription;

        case "startDateUtcMilli":
          return getLocalTimestamp(row.startDateUtcMilli || 0, true);

        case "endDateUtcMilli":
          return getLocalTimestamp(row.endDateUtcMilli || 0, true);

        case "participatingMembers":
          return (
            <div style={{ textAlign: "center" }}>
              <div style={{ fontSize: "15px", marginBottom: "8px" }}>
                {row.participatingMembers.length}
              </div>
              {row.participatingMembers.length > 0 && (
                <Button
                  style={{
                    backgroundColor: "#24272C",
                    color: "#FFFFFF",
                    borderRadius: "999px",
                    padding: "6px 14px",
                    fontSize: "11px",
                    fontWeight: 700,
                    textTransform: "uppercase",
                    boxShadow: "none",
                    minWidth: 0,
                    lineHeight: 1.2,
                    whiteSpace: "normal",
                    maxWidth: "100%",
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    setParticipatingMembersModalOpen(true);
                    setMemberModalOpenedIsActive(isActive);
                    setMemberModalOpenedForCampaignsId(row.id);
                  }}
                  variant="contained"
                >
                  {enumStrings.shopLocal.fullPageShopLocalCampaign.openList}
                </Button>
              )}
            </div>
          );

        case "prizeDrawParticipants":
          return (
            <div style={{ textAlign: "center" }}>
              <div style={{ fontSize: "15px", marginBottom: "8px" }}>
                {(row?.prizeDrawParticipants || []).length}
              </div>
              {(row?.prizeDrawParticipants || []).length > 0 && (
                <Button
                  style={{
                    backgroundColor: "#24272C",
                    color: "#FFFFFF",
                    borderRadius: "999px",
                    padding: "6px 14px",
                    fontSize: "11px",
                    fontWeight: 700,
                    textTransform: "uppercase",
                    boxShadow: "none",
                    lineHeight: 1.2,
                    minWidth: 0,
                    whiteSpace: "normal",
                    maxWidth: "100%",
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    setMemberModalOpenedForCampaignsId(row.id);
                    setParticipantModalOpen(true);
                  }}
                  variant="contained"
                >
                  {
                    enumStrings.shopLocal.fullPageShopLocalCampaign
                      .openListAndPickWinner
                  }
                </Button>
              )}
            </div>
          );

        case "status":
          return isActive ? (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "8px",
              }}
            >
              <span
                style={{
                  color: isUpcoming ? "#525100" : "#00B621",
                  fontWeight: 700,
                  fontSize: "14px",
                  textTransform: "uppercase",
                  letterSpacing: "0.04em",
                }}
              >
                {isUpcoming
                  ? enumStrings.shopLocal.fullPageShopLocalCampaign.upcoming
                  : enumStrings.shopLocal.fullPageShopLocalCampaign.active}
              </span>
              <Button
                style={{
                  backgroundColor: "#E53935",
                  color: "#FFFFFF",
                  borderRadius: "999px",
                  padding: "6px 14px",
                  fontSize: "11px",
                  fontWeight: 700,
                  textTransform: "uppercase",
                  boxShadow: "none",
                  minWidth: 0,
                  lineHeight: 1.2,
                  whiteSpace: "normal",
                  maxWidth: "100%",
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  setEndCampaignModalOpen(() => {
                    setEndModalCampaignId(row.id);
                    return true;
                  });
                }}
                variant="contained"
              >
                {enumStrings.shopLocal.fullPageShopLocalCampaign.end}
              </Button>
            </div>
          ) : (
            <span
              style={{
                color: "#9CA3AF",
                fontWeight: 700,
                fontSize: "14px",
                textTransform: "uppercase",
                letterSpacing: "0.04em",
              }}
            >
              {enumStrings.shopLocal.fullPageShopLocalCampaign.ended}
            </span>
          );

        case "updateActiveCampaign":
          return isActive ? (
            <Button
              variant="contained"
              style={{
                backgroundColor: "#E1A731",
                color: "#FFFFFF",
                fontSize: "12px",
                fontWeight: 700,
                borderRadius: "999px",
                padding: "8px 14px",
                textTransform: "uppercase",
                boxShadow: "none",
                minWidth: 0,
                lineHeight: 1.2,
                whiteSpace: "normal",
                maxWidth: "100%",
              }}
              onClick={(e) => {
                e.stopPropagation();
                history.push(RedirectUri.updateShopLocal, {
                  shopLocalCampaignId: row.id,
                });
              }}
            >
              {enumStrings.shopLocal.fullPageShopLocalCampaign.edit}
            </Button>
          ) : null;

        default:
          return null;
      }
    },
    [classes.modalButton, enumStrings, history]
  );

  // Handle row click for navigation
  const handleRowClick = React.useCallback(
    (row: TableShopLocalCampaignDataType) => {
      if (mode === "active") {
        history.push(RedirectUri.updateShopLocal, {
          shopLocalCampaignId: row.id,
        });
      }
    },
    [history, mode]
  );

  // Empty state message
  const emptyMessage =
    mode === "active"
      ? enumStrings.shopLocal.fullPageShopLocalCampaign.noActiveContests
      : enumStrings.shopLocal.fullPageShopLocalCampaign.noPreviousContests;

  return (
    <>
      {endCampaignModalOpen && (
        <EndCampaignModal
          campaignId={endModalCampaignId}
          closeModal={() => setEndCampaignModalOpen(false)}
        />
      )}
      {participatingMembersModalOpen && (
        <Modal
          className={classes.modal}
          open={participatingMembersModalOpen}
          onClose={() => setParticipatingMembersModalOpen(false)}
        >
          <div className={classes.cleanModal}>
            <button
              type="button"
              className={classes.cleanCloseBtn}
              onClick={() => setParticipatingMembersModalOpen(false)}
              aria-label={enumStrings.shopLocal.createShopLocalCampaign.close}
            >
              ×
            </button>
            <img
              src={ListIcon}
              alt=""
              style={{
                width: "72px",
                height: "72px",
                display: "block",
                marginBottom: "12px",
              }}
            />
            <h2 className={classes.cleanModalTitle}>
              Participating Member Companies
            </h2>
            <p className={classes.cleanModalDesc}>
              The participation code and the number of Chamber Perks App™
              users who have entered the prize draw by redeeming a perk from
              each participating company are displayed under each company name.
            </p>
            {participatingMemberCompaniesTable}
            <div className={classes.cleanActionRow}>
              {memberModalOpenedIsActive && (
                <button
                  type="button"
                  className={classes.cleanDarkBtn}
                  onClick={() =>
                    history.push(RedirectUri.updateShopLocal, {
                      shopLocalCampaignId: memberModalOpenedForCampaignsId,
                    })
                  }
                >
                  {enumStrings.fullPageShopLocal.updateMemberList}
                </button>
              )}
              {sortedMembersData.length > 0 && (
                <CSVLink
                  data={[
                    [
                      enumStrings.shopLocal.fullPageShopLocalCampaign
                        .memberCompanyName,
                      enumStrings.shopLocal.fullPageShopLocalCampaign
                        .participatingCode,
                      enumStrings.shopLocal.fullPageShopLocalCampaign
                        .usersInPrizeDraw,
                    ],
                    ...(sortedMembersData || []).map((member) => {
                      if (!member) return ["", "", ""];

                      const participantEmails = getParticipantEmailsForMember(
                        member.participationCode || ""
                      );

                      return [
                        member.memberName || "",
                        member.participationCode || "",
                        participantEmails.length > 0
                          ? `Total users: ${
                              participantEmails.length
                            }\n\n${participantEmails
                              .map((email) => `${email || ""}`)
                              .join("\n")}`
                          : member.numberOfParticipants || 0,
                      ];
                    }),
                  ]}
                  filename={`Shop Local Campaign Participating Member Companies.csv`}
                  style={{ textDecoration: "none" }}
                >
                  <button type="button" className={classes.cleanDarkBtn}>
                    <GetAppIcon style={{ fontSize: 18 }} />
                    DOWNLOAD LIST
                  </button>
                </CSVLink>
              )}
            </div>
          </div>
        </Modal>
      )}

      {participantModalOpen && (
        <Modal className={classes.modal} open={participantModalOpen}>
          <div className={classes.cleanModal}>
            <button
              type="button"
              className={classes.cleanCloseBtn}
              onClick={() => setParticipantModalOpen(false)}
              aria-label={enumStrings.shopLocal.createShopLocalCampaign.close}
            >
              ×
            </button>
            <img
              src={ListIcon}
              alt=""
              style={{
                width: "72px",
                height: "72px",
                display: "block",
                marginBottom: "12px",
              }}
            />
            <h2 className={classes.cleanModalTitle}>
              {
                enumStrings.shopLocal.updateChamberShopLocalCampaign
                  .prizeDrawParticipantsTitle
              }
            </h2>
            <p className={classes.cleanModalDesc}>
              {
                enumStrings.shopLocal.updateChamberShopLocalCampaign
                  .prizeDrawParticipantsDesc
              }
            </p>
            {cpaUsersParticipatingInDrawList}
            <div className={classes.cleanActionRow}>
              <button
                type="button"
                className={classes.cleanGoldIconBtn}
                onClick={() => {
                  setRandomWinnerEmailFunc();
                  setRandomWinnerModalOpen(true);
                }}
              >
                <span className={classes.cleanGoldIconCircle}>
                  <GroupIcon />
                </span>
                {
                  enumStrings.shopLocal.updateChamberShopLocalCampaign
                    .pickRandomWinnerButton
                }
              </button>
              {memberModalOpenedForCampaignsId &&
                Boolean(
                  allShopLocalCampaignData?.find(
                    (campaign) =>
                      campaign.id === memberModalOpenedForCampaignsId
                  )?.prizeDrawParticipants?.length
                ) && (
                  <CSVLink
                    data={[
                      [
                        enumStrings.shopLocal.updateChamberShopLocalCampaign
                          .participantEmailColumn,
                        enumStrings.shopLocal.updateChamberShopLocalCampaign
                          .entryEarnedFromMemberColumn,
                      ],
                      ...(sortPrizeDrawParticipantsByRedemptions(
                        (allShopLocalCampaignData || []).find(
                          (campaign) =>
                            campaign.id === memberModalOpenedForCampaignsId
                        )?.prizeDrawParticipants || []
                      ).map((participant) => {
                        const memberNames = participant.redeemedAtMemberIds
                          .map((id) => {
                            const member =
                              allChamberMemberData?.getAllChamberMembers?.find(
                                (m) => m.id === id
                              );
                            return member
                              ? `${member.name}`
                              : `Unknown Member (${id})`;
                          })
                          .join("\n");

                        return [participant.userEmail, memberNames];
                      }) || []),
                    ]}
                    filename={`Prize Draw Participants.csv`}
                    style={{ textDecoration: "none" }}
                  >
                    <button type="button" className={classes.cleanDarkBtn}>
                      <GetAppIcon style={{ fontSize: "18px" }} />
                      {
                        enumStrings.shopLocal.updateChamberShopLocalCampaign
                          .downloadList
                      }
                    </button>
                  </CSVLink>
                )}
            </div>
          </div>
        </Modal>
      )}

      {randomWinnerModalOpen && (
        <Modal className={classes.modal} open={randomWinnerModalOpen}>
          <div className={classes.cleanModal} style={{ width: "560px" }}>
            <button
              type="button"
              className={classes.cleanCloseBtn}
              onClick={() => setRandomWinnerModalOpen(false)}
              aria-label={enumStrings.shopLocal.createShopLocalCampaign.close}
            >
              ×
            </button>
            <div className={classes.cleanWinnerIconCircle}>
              <EmojiEventsIcon
                style={{ fontSize: "64px", color: "#E1A731" }}
              />
            </div>
            <h2 className={classes.cleanModalTitle}>
              {
                enumStrings.shopLocal.updateChamberShopLocalCampaign
                  .randomWinnerTitle
              }
            </h2>
            {randomWinnerEmail ? (
              <>
                <p className={classes.cleanWinnerEmail}>{randomWinnerEmail}</p>
                <p className={classes.cleanWinnerSubtitle}>
                  {enumStrings.shopLocal.updateChamberShopLocalCampaign.randomWinnerSubtitle.replace(
                    "{{count}}",
                    String(randomWinnerCount)
                  )}
                </p>
              </>
            ) : (
              <p className={classes.cleanModalDesc}>
                {
                  enumStrings.shopLocal.createShopLocalCampaign
                    .noWinnerYet
                }
              </p>
            )}
          </div>
        </Modal>
      )}

      {isMobile ? (() => {
        const q = mobileSearch.trim().toLowerCase();
        const filtered = q
          ? allTableShopLocalCampaignData.filter((row) => {
              const haystack = [row.campaignName || "", row.prizeDescription || ""].join(" ").toLowerCase();
              return haystack.includes(q);
            })
          : allTableShopLocalCampaignData;
        const menuCampaign = filtered.find((c) => c.id === mobileMenuCampaignId);
        return (
          <div className={classes.mobileList}>
            <TextField
              className={classes.mobileSearchBar}
              variant="outlined"
              size="small"
              placeholder={enumStrings.shopLocal.fullPageShopLocalCampaign.searchPlaceholder}
              value={mobileSearch}
              onChange={(e) => setMobileSearch(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon style={{ color: "#666", fontSize: "18px" }} />
                  </InputAdornment>
                ),
              }}
            />
            {filtered.length === 0 ? (
              <div className={classes.mobileEmpty}>{emptyMessage}</div>
            ) : (
              filtered.map((row) => {
                const isActive = row.status === ShopLocalCampaignStatusEnum.Active;
                const isUpcoming = isActive && Date.now() < row.startDateUtcMilli;
                const statusLabel = !isActive
                  ? enumStrings.shopLocal.fullPageShopLocalCampaign.ended
                  : isUpcoming
                  ? enumStrings.shopLocal.fullPageShopLocalCampaign.upcoming
                  : enumStrings.shopLocal.fullPageShopLocalCampaign.active;
                const pillClass = !isActive
                  ? classes.mobileStatusPill
                  : `${classes.mobileStatusPill} ${isUpcoming ? classes.mobileStatusPillUpcoming : classes.mobileStatusPillActive}`;
                const count = (row?.prizeDrawParticipants || []).length;
                const participatingCount = (row?.participatingMembers || []).length;
                return (
                  <div key={row.id} className={classes.mobileCard}>
                    <div className={classes.mobileCardTop}>
                      <div className={classes.mobileTitles}>
                        <div className={classes.mobileCampaignTitle}>{row.campaignName}</div>
                        {row.prizeDescription ? (
                          <div className={classes.mobileCampaignSubtitle}>{row.prizeDescription}</div>
                        ) : null}
                      </div>
                      <span className={pillClass}>{statusLabel}</span>
                      {isActive && (
                        <IconButton
                          size="small"
                          className={classes.mobileMenuBtn}
                          onClick={(e) => {
                            e.stopPropagation();
                            setMobileMenuAnchor(e.currentTarget);
                            setMobileMenuCampaignId(row.id);
                          }}
                        >
                          <MoreVertIcon fontSize="small" />
                        </IconButton>
                      )}
                    </div>
                    <div className={classes.mobileDivider} />
                    <div className={classes.mobileMetaRow}>
                      <span className={classes.mobileMetaLabel}>{enumStrings.fullPageShopLocal.prizeDescription}</span>
                      <span className={classes.mobileMetaValue}>{row.prizeDescription || "-"}</span>
                    </div>
                    <div className={classes.mobileMetaRow}>
                      <span className={classes.mobileMetaLabel}>{enumStrings.fullPageShopLocal.participatingMembers}</span>
                      <span className={classes.mobileMetaValue}>{participatingCount}</span>
                    </div>
                    <div className={classes.mobileMetaRow}>
                      <span className={classes.mobileMetaLabel}>{enumStrings.fullPageShopLocal.startDate}</span>
                      <span className={classes.mobileMetaValue}>{formatShortDate(row.startDateUtcMilli || 0)}</span>
                    </div>
                    <div className={classes.mobileMetaRow}>
                      <span className={classes.mobileMetaLabel}>{enumStrings.fullPageShopLocal.endDate}</span>
                      <span className={classes.mobileMetaValue}>{formatShortDate(row.endDateUtcMilli || 0)}</span>
                    </div>
                    <div className={classes.mobileDivider} />
                    {participatingCount > 0 && (
                      <div className={classes.mobileBottomRow}>
                        <div>
                          <div className={classes.mobileCountNumber}>
                            {participatingCount}
                          </div>
                          <div className={classes.mobileCountLabel}>
                            {
                              enumStrings.fullPageShopLocal
                                .participatingMembers
                            }
                          </div>
                        </div>
                        <Button
                          className={classes.mobileViewUsersBtn}
                          onClick={() => {
                            setParticipatingMembersModalOpen(true);
                            setMemberModalOpenedIsActive(isActive);
                            setMemberModalOpenedForCampaignsId(row.id);
                          }}
                        >
                          {
                            enumStrings.shopLocal.fullPageShopLocalCampaign
                              .openList
                          }
                        </Button>
                      </div>
                    )}
                    {count > 0 && (
                      <div className={classes.mobileBottomRow}>
                        <div>
                          <div className={classes.mobileCountNumber}>{count}</div>
                          <div className={classes.mobileCountLabel}>
                            {enumStrings.fullPageShopLocal.prizeDrawParticipants}
                          </div>
                        </div>
                        <Button
                          className={classes.mobileViewUsersBtn}
                          onClick={() => {
                            setMemberModalOpenedForCampaignsId(row.id);
                            setParticipantModalOpen(true);
                          }}
                        >
                          {
                            enumStrings.shopLocal.fullPageShopLocalCampaign
                              .openListAndPickWinner
                          }
                        </Button>
                      </div>
                    )}
                  </div>
                );
              })
            )}
            <Menu
              anchorEl={mobileMenuAnchor}
              open={Boolean(mobileMenuAnchor) && !!menuCampaign}
              onClose={() => {
                setMobileMenuAnchor(null);
                setMobileMenuCampaignId(null);
              }}
              PaperProps={{ style: { borderRadius: "10px", minWidth: "160px" } }}
            >
              <MenuItem
                onClick={() => {
                  const id = mobileMenuCampaignId;
                  setMobileMenuAnchor(null);
                  setMobileMenuCampaignId(null);
                  if (id) {
                    history.push(RedirectUri.updateShopLocal, { shopLocalCampaignId: id });
                  }
                }}
                style={{ fontSize: "14px", padding: "10px 16px" }}
              >
                {enumStrings.shopLocal.fullPageShopLocalCampaign.edit}
              </MenuItem>
              <MenuItem
                onClick={() => {
                  const id = mobileMenuCampaignId;
                  setMobileMenuAnchor(null);
                  setMobileMenuCampaignId(null);
                  if (id) {
                    setEndModalCampaignId(id);
                    setEndCampaignModalOpen(true);
                  }
                }}
                style={{ fontSize: "14px", padding: "10px 16px", color: "#C62828" }}
              >
                {enumStrings.shopLocal.fullPageShopLocalCampaign.end}
              </MenuItem>
            </Menu>
          </div>
        );
      })() : (
      <div
        className={classes.desktopTableWrap}
      >
        <CommonTable<TableShopLocalCampaignDataType>
          data={allTableShopLocalCampaignData}
          columns={columns}
          defaultSortColumn="startDateUtcMilli"
          defaultSortOrder="desc"
          rowKeyField="id"
          renderCell={renderCell}
          onRowClick={mode === "active" ? handleRowClick : undefined}
          emptyMessage={emptyMessage}
          searchPlaceholder={enumStrings.shopLocal.fullPageShopLocalCampaign.searchPlaceholder}
          searchFields={["campaignName", "prizeDescription"]}
        />
      </div>
      )}
    </>
  );
}
